import {
  boPhanSearchColumns,
  chiPhiSearchColumns,
  dotThanhToanSearchColumns,
  hopDongSearchColumns,
  kheUocSearchColumns,
  lenhSanXuatSearchColumns,
  phiSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  vuViecSearchColumns
} from '@/constants';
import { BoPhan, ChiPhi, DotThanhToan, HopDong, KheUoc, Phi, VatTu, VuViec } from '@/types/schemas';
import { SearchDialogActions, SearchDialogState } from '../../hooks';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface ObjectTabProps {
  searchState: {
    state: SearchDialogState;
    actions: SearchDialogActions;
  };
}

const ObjectTab: React.FC<ObjectTabProps> = ({ searchState: { state, actions } }) => {
  return (
    <div className='h-96 w-[800px] min-w-[800px] space-y-4 p-4'>
      <div className='flex flex-col space-y-2'>
        {/* Mã bộ phận */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã bộ phận:</Label>
          <SearchField<BoPhan>
            searchEndpoint={`/${QUERY_KEYS.BO_PHAN}/`}
            searchColumns={boPhanSearchColumns}
            dialogTitle='Danh mục bộ phận'
            columnDisplay={`ma_bp`}
            displayRelatedField={`ten_bp`}
            value={state.boPhan?.ma_bp || ''}
            relatedFieldValue={state.boPhan?.ten_bp || ''}
            onRowSelection={actions.setBoPhan}
            className='w-full'
          />
        </div>

        {/* Mã vụ việc */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã vụ việc:</Label>
          <SearchField<VuViec>
            searchEndpoint={`/${QUERY_KEYS.VU_VIEC}/`}
            searchColumns={vuViecSearchColumns}
            dialogTitle='Danh mục vụ việc'
            columnDisplay={`ma_vu_viec`}
            displayRelatedField={`ten_vu_viec`}
            value={state.vuViec?.ma_vu_viec || ''}
            relatedFieldValue={state.vuViec?.ten_vu_viec || ''}
            onRowSelection={actions.setVuViec}
            className='w-full'
          />
        </div>

        {/* Mã hợp đồng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã hợp đồng:</Label>
          <SearchField<HopDong>
            searchEndpoint={`/${QUERY_KEYS.HOP_DONG}/`}
            searchColumns={hopDongSearchColumns}
            dialogTitle='Danh mục hợp đồng'
            columnDisplay={`ma_hd`}
            displayRelatedField={`ten_hd`}
            value={state.hopDong?.ma_hd || ''}
            relatedFieldValue={state.hopDong?.ten_hd || ''}
            onRowSelection={actions.setHopDong}
            className='w-full'
          />
        </div>

        {/* Mã đợt thanh toán */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã đợt thanh toán:</Label>
          <SearchField<DotThanhToan>
            searchEndpoint={`/${QUERY_KEYS.DOT_THANH_TOAN}/`}
            searchColumns={dotThanhToanSearchColumns}
            dialogTitle='Danh mục đợt thanh toán'
            columnDisplay={`ma_dtt`}
            displayRelatedField={`ten_dtt`}
            value={state.dotThanhToan?.ma_dtt || ''}
            relatedFieldValue={state.dotThanhToan?.ten_dtt || ''}
            onRowSelection={actions.setDotThanhToan}
            className='w-full'
          />
        </div>

        {/* Mã khế ước */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã khế ước:</Label>
          <SearchField<KheUoc>
            searchEndpoint={`/${QUERY_KEYS.KHE_UOC}/`}
            searchColumns={kheUocSearchColumns}
            dialogTitle='Danh mục khế ước'
            columnDisplay={`ma_ku`}
            displayRelatedField={`ten_ku`}
            value={state.kheUoc?.ma_ku || ''}
            relatedFieldValue={state.kheUoc?.ten_ku || ''}
            onRowSelection={actions.setKheUoc}
            className='w-full'
          />
        </div>

        {/* Mã phí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã phí:</Label>
          <SearchField<Phi>
            searchEndpoint={`/${QUERY_KEYS.PHI}/`}
            searchColumns={phiSearchColumns}
            dialogTitle='Danh mục phí'
            columnDisplay={`ma_phi`}
            displayRelatedField={`ten_phi`}
            value={state.phi?.ma_phi || ''}
            relatedFieldValue={state.phi?.ten_phi || ''}
            onRowSelection={actions.setPhi}
            className='w-full'
          />
        </div>

        {/* Mã sản phẩm */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã sản phẩm:</Label>
          <SearchField<VatTu>
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục sản phẩm'
            columnDisplay={`ma_vt`}
            displayRelatedField={`ten_vt`}
            value={state.sanPham?.ma_vt || ''}
            relatedFieldValue={state.sanPham?.ten_vt || ''}
            onRowSelection={actions.setSanPham}
            className='w-full'
          />
        </div>

        {/* Số lệnh */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Số lệnh:</Label>
          <SearchField<MuaHangRecord>
            searchEndpoint={`/${QUERY_KEYS.LENH_SAN_XUAT}/`}
            searchColumns={lenhSanXuatSearchColumns}
            dialogTitle='Danh mục lệnh sản xuất'
            columnDisplay={`ma_lsx`}
            displayRelatedField={`ten_lsx`}
            value={state.lenhSanXuat?.ma_lsx || ''}
            relatedFieldValue={state.lenhSanXuat?.ten_lsx || ''}
            onRowSelection={actions.setLenhSanXuat}
            className='w-full'
          />
        </div>

        {/* Mã chi phí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã chi phí:</Label>
          <SearchField<ChiPhi>
            searchEndpoint={`/${QUERY_KEYS.CHI_PHI}/`}
            searchColumns={chiPhiSearchColumns}
            dialogTitle='Danh mục chi phí'
            columnDisplay={`ma_cp`}
            displayRelatedField={`ten_cp`}
            value={state.chiPhi?.ma_cp || ''}
            relatedFieldValue={state.chiPhi?.ten_cp || ''}
            onRowSelection={actions.setChiPhi}
            className='w-full'
          />
        </div>
      </div>
    </div>
  );
};

export default ObjectTab;
